module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "widgets"
  }, [_c('div', {
    staticClass: "ui clearing basic top segment"
  }, [_c('h2', {
    staticClass: "ui left floated header"
  }, [_vm._v("Monthly Overview")]), _vm._v(" "), _c('h5', {
    staticClass: "ui right floated header"
  }, [_c('wiki-selector', {
    attrs: {
      "wiki": _vm.wiki,
      "single": "true"
    },
    on: {
      "wiki": _vm.wikiSelected
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.areas), function(a) {
    return _c('div', {
      key: a.state.id,
      staticClass: "ui basic area segment"
    }, [_c('dashboard-area', {
      attrs: {
        "area": a.state
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-96c06002"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 396
// module chunks = 1